export class LogsSchemaEntry {
    'resourceId';
    'resourceName';
    'cloudProvider';
    'schemas';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "resourceName",
            "baseName": "resourceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "Provider",
            "format": ""
        },
        {
            "name": "schemas",
            "baseName": "schemas",
            "type": "Array<LogsSchema>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return LogsSchemaEntry.attributeTypeMap;
    }
    constructor() {
    }
}
